import { useState } from "react";
import { CheckInVehicle } from "./CheckInVehicle";
import { CheckInVisitor } from "./CheckInVisitor";
import { useTranslation } from "react-i18next";
import { PageLayout } from "../../Components/PageLayout";

const PageButtons = ({ setForm }) => {
  const { t } = useTranslation();
  return (
    <div className="">
      <div className="overview-header">
        <h1 className="global-h1 light-black">{t("page-headers.check-in")}</h1>
      </div>
      <div className="form-cont">
        <h4 className=" global-h4 bottom-space">
          {t("forms.type.check-in-header")}
        </h4>
        <div className="flex-1">
          <button
            id="vehicle-btn"
            data-testid="vehicle-btn"
            onClick={() => setForm("Vehicle")}
            className="check-in-option"
            aria-label="vehicle"
          >
            {t("buttons.vehicle")}
          </button>
          <button
            onClick={() => setForm("Visitor")}
            className="check-in-option"
          >
            {t("buttons.visitor")}
          </button>
        </div>
      </div>
    </div>
  );
};
const CheckInView = () => {
  const [checkForm, setForm] = useState("");
  const { t } = useTranslation();

  const handleClose = () => {
    setForm("");
  };

  return (
    <PageLayout title={"Check In"}>
      <div className="checkin-wrapper">
        {!checkForm && <PageButtons setForm={setForm} />}
        {checkForm === "Vehicle" ? (
          <CheckInVehicle onClose={handleClose} />
        ) : null}
        {checkForm === "Visitor" ? (
          <CheckInVisitor onClose={handleClose} english={t} />
        ) : null}
      </div>
    </PageLayout>
  );
};

export default CheckInView;